import { Button, Calendar, Popup } from "antd-mobile";
import dayjs from "dayjs";
import { useState } from "react";
import styles from "./styles.module.scss";
type RangeSelectPopupProps = {
  visible: boolean;
  data: [string, string];
  onCancel: () => void;
  onSubmit: (val: [string, string]) => void;
};
export const RangeSelectPopup = (props: RangeSelectPopupProps) => {
  const today = dayjs();
  const [val, setVal] = useState<[Date, Date]>(() => [today.toDate(), today.toDate()]);
  const onSubmit = () => {
    const value: [string, string] = [dayjs(val[0]).format("YYYY-MM-DD"), dayjs(val[1]).format("YYYY-MM-DD")];
    typeof props.onSubmit === "function" && props.onSubmit(value);
  };
  return <Popup visible={props.visible}
  // closeOnMaskClick={false}
  onClose={props.onCancel} onMaskClick={props.onCancel} data-sentry-element="Popup" data-sentry-component="RangeSelectPopup" data-sentry-source-file="index.tsx">
      {/* <div className={styles.header}>日期选择</div> */}
      <div className={styles.content}>
        <Calendar selectionMode="range" value={val} onChange={val => {
        if (val === null) {
          setVal([today.toDate(), today.toDate()]);
        } else {
          setVal(val);
        }
      }} data-sentry-element="Calendar" data-sentry-source-file="index.tsx" />
      </div>

      <div className={styles.footer} onClick={() => {
      onSubmit();
    }}>
        <Button className={"common-submit-button"} data-sentry-element="Button" data-sentry-source-file="index.tsx">确定</Button>
      </div>
    </Popup>;
};